module.exports = __webpack_public_path__ + "static/media/intelli-nail.e5651571.jpg";